import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import AddPSUComponent from '../../components/AddPSUComponent/AddPSUComponent'

const AddPSUDevice = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <AddPSUComponent/>
                </div>
            </div>
        </div>
    )
}

export default AddPSUDevice
